export const Bio = {
  name: "Arbaz Khan",
  roles: [
    "Technical Team Lead",
    "Full Stack Developer",
    "Blockchain Developer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/ArbazKhanGul",
  resume:
    "https://drive.google.com/file/d/1TVN_aUZ_6hyO7C-rcxJx3fyfbYs42yn8/view",
  linkedin: "https://www.linkedin.com/in/arbazkhangul/",
  // twitter: "https://twitter.com/RishavChanda",
  whats: "https://wa.me/923115914586",
  facebook: "https://www.facebook.com/profile.php?id=100008751400618",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image: "redux.png",
      },
      {
        name: "Next Js",
        image: "/next.png",
      },
      {
        name: "HTML",
        image: "/html.png",
      },
      {
        name: "CSS",
        image: "/css.png",
      },
      {
        name: "JavaScript",
        image: "javascript.png",
      },
      {
        name: "Bootstrap",
        image: "bootstrap.svg",
      },
      {
        name: "Tailwind",
        image: "tailwind.png",
      },
      {
        name: "Sass",
        image: "sass.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "/node.png",
      },
      {
        name: "Express Js",
        image: "express.png",
      },
      {
        name: "Kafka",
        image: "kafka.png",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image: "/mongodb.svg",
      },
      {
        name: "NestJs",
        image: "/nest.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Blockchain",
    skills: [
      {
        name: "Ethereum",
        image: "/ethereum.png",
      },
      {
        name: "Solidity",
        image: "/solidity.png",
      },
      {
        name: "Ether.js",
        image: "/ether.png",
      },
      {
        name: "Hardhat",
        image: "/hardhat.png",
      },
      {
        name: "Viem",
        image: "/viem.png",
      },
      {
        name: "Web3.js",
        image: "/web3.png",
      },
      {
        name: "NFT",
        image: "/nft.jpeg",
      },
      {
        name: "Wagmi",
        image: "/wagmi.jpeg",
      },
      {
        name: "IPFS",
        image: "/ipfs.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "/git.png",
      },
      {
        name: "GitHub",
        image: "github.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },

      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "/postman.png",
      },

      {
        name: "Figma",
        image: "/figma.png",
      },
      {
        name: "AWS",
        image: "/aws.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/axitech.png",
    role: "Technical Team Lead",
    company: "Axi Technologies",
    date: "May 2025 – Present",
    desc: "Promoted to Technical Team Lead at Axi Technologies, I now spearhead strategic technical initiatives and mentor cross-functional development teams. In this leadership role, I oversee the architecture and development of enterprise-scale, real-time applications while driving technical excellence across multiple projects. I continue to lead the backend development of mission-critical systems using Node.js, uWebSockets, Express, and Next.js, while now also managing team workflows, code reviews, and technical roadmaps. My responsibilities include architecting and optimizing the WhatsApp-like national chat application for 1+ million users, implementing advanced Kafka queue systems, Redis caching strategies, and Elasticsearch indexing solutions. As a team lead, I foster collaborative environments, establish coding standards, guide technical decision-making, and ensure scalable system designs that support rapid business growth and innovation.",
    location: "Rawalpindi, Pakistan",
    skills: [
      "Team Leadership",
      "Technical Architecture",
      "Node.js",
      "uWebSockets",
      "Express.js",
      "Next.js",
      "Kafka",
      "Redis",
      "Elasticsearch",
      "WebSockets",
      "Microservices",
      "Scalability",
      "Performance Optimization",
      "Real-time Messaging",
      "Code Review",
      "Mentoring",
    ],
    timing: "Full Time - Onsite",
  },
  {
    id: 1,
    img: "/axitech.png",
    role: "Senior Full Stack Developer",
    company: "Axi Technologies",
    date: "Oct 2024 – May 2025",
    desc: "As a Senior Full Stack Developer at Axi Technologies, I led the backend development of high-performance, real-time applications using Node.js, uWebSockets, Express, Next.js, and other modern technologies. I engineered a WhatsApp-like national chat application, leveraging Kafka queue system, Redis, and Elasticsearch for optimal scalability and performance. Additionally, I designed and optimized real-time communication systems with uWebSockets, enabling ultra-low latency messaging for 1 million users. My role involved building efficient and scalable backend architectures, ensuring seamless data processing and message delivery while collaborating with cross-functional teams to enhance system efficiency and introduce new features.",
    location: "Rawalpindi, Pakistan",
    skills: [
      "Node.js",
      "uWebSockets",
      "Express.js",
      "Next.js",
      "Kafka",
      "Redis",
      "Elasticsearch",
      "WebSockets",
      "Microservices",
      "Scalability",
      "Performance Optimization",
      "Real-time Messaging",
    ],
    timing: "Full Time - Onsite",
  },
  {
    id: 2,
    img: "/vrtechsol.png",
    role: "Senior MERN Stack Developer",
    company: "Vrtechsol",
    date: "May 2024 - Sep 2024",
    desc: "As a MERN Stack Developer at vrtechsol, I drive backend development, leveraging Node.js, Express.js, and MongoDB for robust server-side applications. I specialize in implementing RESTful APIs and WebSocket communication while ensuring scalable deployment and performance optimization with AWS services. Additionally, I craft dynamic front-end experiences using Next.js and React, delivering seamless user interactions and immersive interfaces.",
    location: "Lahore, punjab pk",
    skills: [
      "Docker",
      "HTML",
      "Amazon Web Service",
      "Web 3.0",
      "Tailwind Css",
      "AWS",
      "EC2",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Next Js",
    ],
    timing: "Full Time - Onsite",
    doc: "/vrtechexpericene.jpg",
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },

  {
    id: 3,
    img: "/kawiish.jpeg",
    role: "Senior Node.js Developer",
    company: "Kawiish IT Services",
    date: "March 2023 - Apr 2024",
    location: "Abottabad, kpk pk",
    desc: "Spearheaded backend development with Node.js, Express.js, and MongoDB, creating robust server-side applications. Implemented RESTful APIs and WebSocket communication for seamless data exchange, and leveraged AWS services for scalable and reliable deployment. Developed dynamic front-end applications using Next.js and React.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Express JS",
      "HTML",
      "Amazon Web Service",
      "Next JS",
      "Tailwind Css",
      "Mongodb",
      "CSS",
      "JavaScript",
    ],
    doc: "/kawish.jpeg",
    timing: "Full Time - Onsite",
  },

  {
    id: 4,
    img: "/techno.jpeg",
    role: "MERN Stack Developer",
    company: "Techno Digital",
    date: "Jan 2024 - Apr 2024",
    location: "Luchnow India",
    desc: "Developed and Deploy responsive and scalable applications using React, Node, Socket.io Express, rest API and also deploy these applications on VPS. Working with cross functional teams to design and develop new features.",
    skills: [
      "ReactJS",
      "Redux",
      "NextJs",
      "NodeJs",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
    timing: "Part Time - Remote",
  },
  {
    id: 5,
    img: "/spider.webp",
    role: "NodeJs Developer",
    company: "Spider Technology",
    date: "Jun 2022 - Feb 2023",
    desc: "At Spider Technology, I spearheaded the development of robust and scalable backend systems utilizing Node.js. My expertise lies in crafting high-performing APIs (RESTful) using frameworks like Express.js.  This focus ensures efficient data processing and seamless integration with various frontend applications.  I actively collaborate with cross-functional teams to design and implement new features, ensuring a cohesive user experience.",
    // doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
    timing: "Full Time - Remote",
  },
  {
    id: 6,
    img: "/freelaunce.jpg",
    role: "MERN STACK & WEB 3.0 Devloper",
    company: "Free Launcing",
    date: "Jan 2022 - Present",
    location: "Worked globally in diverse projects",
    desc: "As a freelancer, I leverage Next.js and React.js to craft dynamic user interfaces, ensuring seamless web experiences. I utilize Node.js, Express.js, and GraphQL for efficient data flow between frontend and backend systems. Additionally, I develop secure smart contracts with Solidity for blockchain projects, prioritizing adherence to industry standards and robustness.",
    skills: [
      "Leadership",
      "ReactJS",
      "Web 3.0",
      "Smart Contracts",
      "Redux",
      "NodeJs",
      "Nest JS",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
      "Postgres",
    ],
    timing: "Part Time - Remote",
  },
  {
    id: 7,
    img: "/nethers.png",
    role: "Web 3.0 Junior Developer",
    company: "Nethers",
    date: "July 2022 - Aug 2022",
    desc: "Linked the React.js frontend with blockchain smart contracts, facilitating smooth interaction and data exchange between the user interface and the decentralized application's core functions",
    skills: [
      "Leadership",
      "ReactJS",
      "Web 3.0",
      "Smart Contracts",
      "Redux",
      "NodeJs",
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB",
    ],

    timing: "Full Time - Remote",
  },
];

export const education = [
  {
    id: 0,
    img: "/comsat.jpg",
    school: "COMSATS Institute of Information and Technology",
    date: "March 2020 - Jan 2024",
    grade: "3.93/4 CGPA (Double Gold Medalist)",
    desc: "I hold a Bachelor's degree in Software Engineering from COMSATS University Islamabad, achieving a remarkable GPA of 3.93 out of 4, along with receiving double gold medals for my outstanding academic performance. My expertise spans across various domains, including Blockchain technology and web development. With a keen interest in innovation, I am continuously learning and adapting to stay abreast of the latest advancements in these fields. My goal is to leverage my knowledge and skills to make impactful contributions to the ever-evolving landscape of technology.",
    degree: "Bachelor of Software Engineering",
  },
  {
    id: 1,
    img: "/tameer.jpeg",
    school: "Tameer-I-Wattan Public School And College",
    date: "May 2017 - May 2019",
    grade: "A+ Grade",
    desc: "I completed my fsc from tameer-i-wattan public school and college , where I studied pre engineering.",
    degree: "FSC in Pre Engineering",
  },
];

export const projects = [
  {
    id: 13,
    title: "Khudi Chat Application",
    description:
      "During my tenure at Axi Technologies, I played a key role in developing Khudi Chat, a WhatsApp-like national chat application designed to support 1 million users. This project required building a highly scalable, real-time messaging system using Node.js, uWebSockets, Kafka queue system, Redis, and Elasticsearch to ensure ultra-low latency and seamless communication. I optimized server performance to handle massive concurrent connections, implemented push notifications and advanced search capabilities, and ensured secure message delivery. Collaborating with cross-functional teams, I contributed to integrating the chat system with national security and communication protocols, making it a robust and efficient solution for real-time communication.",
    image: "/khudi.jpg",
    tags: [
      "Node.js",
      "uWebSockets",
      "Kafka",
      "Redis",
      "Elasticsearch",
      "Real-time Messaging",
      "Scalability",
      "Microservices",
      "Push Notifications",
      "Security & Encryption",
    ],
    category: "communication app",
    webapp: "https://khudi.chat/",
  },

  {
    id: 12,
    title: "FikerLess System",
    description:
      "During my tenure at Vrtechsol, I contributed to the development of FikerLess, a Fiverr-like freelance marketplace that enables users to hire professionals for various services. I was responsible for designing and optimizing the backend architecture, ensuring high performance, scalability, and secure transactions. The platform featured real-time notifications, user authentication, and seamless job management, providing an efficient and user-friendly experience. Through my expertise in Node.js, Next.js, and REST APIs, I helped build a robust and scalable system to support smooth interactions between clients and service providers.",
    image: "/fikerless.webp",
    tags: [
      "Next.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "REST APIs",
      "WebSockets",
      "Authentication",
      "Real-time Notifications",
      "Microservices",
      "Payment Integration",
    ],
    category: "web app",
    webapp: "https://www.fikerless.com/",
  },

  {
    id: 10,
    title: "Royal Falcon Management System",
    // date: " 2023 - Jul 2023",
    description:
      "Currently, I am leading a project titled Royal Falcon Management System, which is a freelance endeavor of mine. This project is being developed for Royal Falcon Limousine, Dubai's largest tourism company. The goal is to automate their vehicle booking and tourism package processes. Through this system, customers can book online via a dedicated app, make payments, and then the booking is authorized by the admin through an admin panel. Subsequently, drivers are assigned to these bookings. Additionally, the system facilitates staff management. The project comprises two apps - one for customers and one for drivers - along with a comprehensive web-based management system. I am responsible for leading the project, coordinating with different developers including app developers, frontend developers, backend developers, and Figma designers. My role involves overseeing backend development and ensuring smooth project management.",
    image: "/royal.jpg",
    tags: [
      "AWS",
      "DNS",
      "Eslint",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "AWS",
      "EC2",
      "WebSocket",
    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://royal-falcon-client.vercel.app",
  },
  {
    id: 9,
    title: "Divine",
    // date: " 2023 - Jul 2023",
    description:
      "At Spider Technology IT Solution, I played a pivotal role in developing the backend infrastructure of the Divine application. Utilizing technologies such as Node.js, Socket.IO, MongoDB, REST API, and push notifications, I contributed to building a robust system tailored for managing disability care services. This platform caters specifically to the needs of disabled individuals, supported by organizations and funded by government initiatives, serving our esteemed Australian client. The Divine application facilitates seamless management with distinct user roles, including owners, managers, and employees. Owners have the ability to create manager profiles, enabling them to oversee tasks and assignments for employees. These employees, in turn, provide essential care services directly to disabled individuals within their residences. While I focused on the backend development, other team members were responsible for creating the Flutter app.",
    image: "/divine.jpg",
    tags: [
      "AWS",
      "DNS",
      "Eslint",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "AWS",
      "EC2",

      "WebSocket",
    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp:
      "https://play.google.com/store/apps/details?id=com.spidertechnology.divinesupport&hl=en",
  },

  {
    id: 2,
    title: "NFT MarketPlace",
    // date: "Jan 2023 - Mar 2023",
    description:
      "In my final year project, I create an innovative NFT marketplace aiming to revolutionize digital asset interaction for creators and collectors. This cutting-edge platform enables seamless sharing and trading of NFTs across social media, empowering users to explore, acquire, and exchange digital collectibles effortlessly. Key features include intuitive trading mechanisms, customizable copyright protection, and secure coin purchases via credit card transactions. Leveraging a comprehensive tech stack including Next.js, Node.js, MongoDB, Redis, Solidity, Ethers.js, Stripe, SendinBlue, and Tailwind CSS, the project delivers a robust user experience at the forefront of the NFT ecosystem",
    image: "/nft.jpg",
    tags: [
      "Node js",
      "Next JS",
      "Soldity",
      "web 3.0",
      "Express",
      "Ether.js",
      "Hardhat",
    ],
    category: "machine learning",
    github: "https://github.com/ArbazKhanGul/textNFTbackend",
    webapp: "https://digitalassets.vercel.app/",
  },
  {
    id: 0,
    title: "Smart Cab",
    // date: "Apr 2023 - May 2023",
    description:
      "During my work period at kawiish, I led the development of SmartCab's backend and admin panel, while another team built the mobile app using Flutter. SmartCab aimed to streamline transportation management by facilitating seamless interactions between passengers and drivers. Passengers could easily request rides through the app, while drivers received notifications to accept requests promptly. The platform efficiently managed driver assignments, tracked ride statuses, and handled administrative tasks. Leveraging technologies like Node.js, Express.js, REST API, React, Tailwind CSS, and MongoDB, we ensured efficient ride handling and robust communication. Real-time updates were provided to passengers and drivers through push notifications and WebSockets. SmartCab aimed to bridge the gap between passengers and drivers, offering a user-friendly ride-sharing solution.",
    image: "smartcab1.jpg",
    tags: [
      "React Js",
      "MongoDb",
      "AWS",
      "EC2",
      "Node Js",
      "Express Js",
      "Redux",
      "Web Sockets",
      "Notification",
    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://smart-cab-admin-panel.vercel.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "Lottery Application",
    // date: "Oct 2022 - Present",
    description:
      "During my tenure at Techno Digital, I developed a dynamic lottery system website using React.js, Node.js, MongoDB, and WebSockets. This innovative platform allowed administrators to create lotteries, while users could participate in up to five lotteries announced daily. Managed seamlessly through the admin panel, the system ensured smooth operations and user engagement. Leveraging cutting-edge technologies, including WebSockets for real-time communication, the platform delivered an interactive and engaging experience. With intuitive interfaces and robust backend infrastructure, the lottery system provided users with a thrilling and secure platform for participation. Experience the excitement of daily lotteries with Techno Digital's advanced system.",
    image: "/lottery.jpeg",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "AWS",
      "NodeMailer",
    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://kolkatatiptop.com/",
  },
  {
    id: 2,
    title: "ERC404 Token",
    // date: "Jan 2023 - Mar 2023",
    description:
      "I recently developed the ERC404 token creation project for a client. This novel standard, freshly launched, is designed to enhance token functionality and overall utility within the Ethereum ecosystem. Leveraging Solidity, Ether.js, Hardhat, and Binance Smart Chain, I meticulously crafted a robust backend infrastructure. This project not only showcases my proficiency in blockchain development but also underscores my dedication to offering holistic solutions for clients navigating the ever-evolving cryptocurrency landscape.",
    image: "/erc404.jpeg",
    tags: ["Soldity", "web 3.0", "Ether.js", "Hardhat"],
    category: "web app",
    github: "https://github.com/ArbazKhanGul/ERC404",
    // webapp: "https://brain-tumor.netlify.app/",
  },
  {
    id: 3,
    title: "DawnTech Portfolio",
    // date: "Dec 2021 - Apr 2022",
    description:
      "For Dawntech, I created portfolio website using Next.js. This platform showcases the company's services, including server offerings, and provides comprehensive contact information. Seamlessly integrating Next.js capabilities, the website offers a seamless user experience, highlighting Dawntech's server solutions and contact details. Users can explore the range of server options offered, along with detailed specifications and pricing, ensuring informed decision-making. The website also features easy-to-use contact forms and direct communication channels, facilitating smooth interactions with potential clients. Dawntech's portfolio website serves as a central hub for clients to learn about their server solutions and reach out for further inquiries, driving engagement and business growth",
    image: "/dawn.jpg",
    tags: ["Next Js", "Nodemailer", "Tailwind Css", "HTML5"],
    category: "web app",
    webapp: "https://dawntech.vercel.app/",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Transfer Coin",
    // date: "Jun 2023 - Jul 2023",
    description:
      "In my personal project, 'Transfer Coin and Maintain History,' I engineered a robust blockchain-based system using Solidity, React.js, and Ether.js. This innovative platform facilitates and tracks cryptocurrency transactions securely, leveraging advanced blockchain technology. Through distributed ledger technology, users can securely transfer digital assets while ensuring a transparent and immutable transaction history. Not only does this project enable seamless peer-to-peer transactions, but it also prioritizes the integrity and security of transaction records. Designed with a focus on reliability and data integrity, 'Transfer Coin and Maintain History' showcases my expertise in blockchain development and dedication to crafting innovative solutions for the digital economy.",
    image: "/transfer.jpeg",
    tags: [
      "React JS",
      "Ethereum",
      "Solidity",
      "Ether.js",
      "JavaScript",
      "Axios",
    ],
    category: "web app",
    github: "https://github.com/ArbazKhanGul/Web3-Project-Transfer",
    webapp: "https://arbaz-web3-transfer.vercel.app/",
  },
  {
    id: 4,
    title: "Google Clone",
    // date: "Jul 2021",
    description:
      "In my personal project, the 'Google Clone,' I harnessed the capabilities of Next.js to craft a sophisticated search engine reminiscent of Google. This cutting-edge web application empowers users to conduct lightning-fast searches across the internet, delivering real-time and precise results. By integrating state-of-the-art technologies and adhering to modern design principles, I ensured an intuitive and seamless user experience. The project showcases my expertise in frontend development and my proficiency in building intricate web applications with Next.js. Whether you're seeking information, images, or videos, this Google Clone promises a superior search experience tailored to your preferences",
    image: "/googleclone.png",
    tags: ["Next Js", "CSS", "HTML 5"],
    category: "web app",
    github: "https://github.com/ArbazKhanGul/GoogleClone",
    webapp: "https://arbazkhan-google-clone.vercel.app/",
  },
  {
    id: 5,
    title: "Real Estate",
    // date: "Jun 2021",
    description:
      "In my personal project, the 'Real Estate project,' I utilized React.js to craft a dynamic and user-friendly platform tailored for browsing properties available for sale and rent. Prioritizing intuitive navigation and comprehensive property information, users can effortlessly explore listings, apply filters, and make informed decisions. Drawing upon my expertise in frontend development and user interface design, I aimed to deliver a compelling and engaging experience for users in search of real estate opportunities. This project serves as a testament to my proficiency in React.js and my capability to produce functional and visually appealing web applications.",
    image: "/realestate.jpeg",
    tags: ["React Js", "HTML 5", "CSS", "framer-motion", "javascript"],
    category: "web app",
    github: "https://github.com/ArbazKhanGul/Realestate",
    webapp: "https://arbaz-realestate.vercel.app/",
  },
  {
    id: 6,
    title: "Snapchat Clone",
    // date: "Jun 2021",
    description:
      "In my personal project, the 'Snapchat Clone Project,' I embarked on an advanced React.js endeavor aimed at replicating the functionality and aesthetics of the popular multimedia messaging app, Snapchat. This undertaking showcases a nuanced comprehension of React.js concepts and sophisticated frontend development techniques. Key highlights include multimedia sharing featuring ephemeral content, robust user authentication, and dynamic UI components. By harnessing the power of React.js, the project delivers a seamless user experience characterized by responsive design and fluid animations reminiscent of the original Snapchat application. Through this endeavor, I demonstrate my expertise in React.js development, UI/UX design, and frontend architecture, cementing its status as a valuable asset within my portfolio",
    image: "/snapchatclone.jpg",
    tags: ["React Js", "API", "Axios", "Firebase", "React Hooks"],
    category: "web app",
    github: "https://github.com/ArbazKhanGul/Snapchat-clone",
    webapp: "https://snapchat-clone-arbaz.vercel.app/",
  },
  {
    id: 7,
    title: "Expense Tracker",
    description:
      "Finance Tracker is my personal project, a comprehensive web application designed to empower users in managing their finances efficiently. Utilizing GraphQL, React, Node.js, and Express, I've crafted a platform that offers a seamless user experience for tracking spending and savings. Users can securely sign up, log in, and record transactions, categorizing them for easy organization. With a graphical representation of spending patterns and savings trends, users gain valuable insights into their financial habits. Customizable categories, along with search and filter functionalities, enhance user control and accessibility. Finance Tracker prioritizes ensuring user privacy and confidentiality.",
    image: "/expensetrack.jpg",
    tags: [
      "Appolo Graphql",
      "Graphql",
      "Node.js",
      "Express.js",
      "React.js",
      "Tailwind CSS",
    ],
    category: "android app",
    github: "https://github.com/ArbazKhanGul/transactionProject_graphql",
    // webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
